<template>
  <!-- 报名门票使用情况 -->
  <div class="ticket-title">
    <p class="p" v-if="peopleInfo.use_status == 3">您购买的本场会议门票已过期，请联系平台退款 ></p>
    <div class="message">
      <van-row>
        <van-col span="15" style="font-size:14px;font-weight:600">
          <span>
            <img
              src="../../assets/images//blue.png"
              alt
              style="vertical-align: middle;height:16px;margin:0px 6px 2px 0px"
            />参会人详细信息
          </span>
        </van-col>
        <van-col span="9" style="text-align: right;color:#a8a8a8" v-if="peopleInfo.modify_order == false">修改信息</van-col>
        <van-col span="9" style="text-align: right;color:#477cdf" v-else @click="goadd()">修改信息</van-col>
      </van-row>
      <van-row v-for="(items,index) in peopleInfo.fields" class="t_box">
        <van-col span="24">
          <span> {{items.name}}：</span>
          <p>
           <template v-if="items.value.constructor == Array">
             <template v-for="(items2,index2) in items.value">
               {{items2}} <template v-if="index2<(items.value.length-1)">,</template>
             </template>
           </template>
           <template v-else>
               {{items.value == ''? '--':items.value}}
           </template>
       </p>
        </van-col>
      </van-row>
        <van-row  class="t_box">
        <van-col span="24">
          <span> 会议地址：</span><p>{{peopleInfo.conference.region}} {{peopleInfo.conference.specific_address}}</p>
      </van-col>
      </van-row>
       <van-row  class="t_box">
        <van-col span="24">
          <span> 会议时间：</span><p>{{peopleInfo.conference.start_time,'M月D日 h:m'|formatDates}} ~ {{peopleInfo.conference.end_time,'M月D日 h:m'|formatDates}}</p>
        </van-col>
      </van-row>
  <!--    <van-row class="t_box">
        <van-col span="24">
          <span> 联系部门：</span>
          <p>{{peopleInfo.dep_name}}</p>
        </van-col>
      </van-row>-->
    </div>
    <div class="wechart">
      <div class="ticket_num">
        <van-row >
          <van-col span="12" style="color:#f95d34">{{peopleInfo.ticket_name}}</van-col>
          <van-col span="12" style="color:#477cdf;text-align: right;" v-if="peopleInfo.use_status == 0">待使用</van-col>
          <van-col span="12" style="color:#a8a8a8;text-align: right;" v-else-if="peopleInfo.use_status == 1">已使用</van-col>
          <van-col span="12" style="color:#f95d34;text-align: right;" v-else-if="peopleInfo.use_status == 3">已过期</van-col>
        </van-row>
      </div>
      <div class="erwei" id="qrcode">
      </div>
      <div class="foot_text">
        <p class="ps" style="color: black" v-if="peopleInfo.use_status == 3">
          该门票已过期，请联系平台退款
          <!--<span style="color: #2b68da;">退款</span>-->
        </p>
        <p class="ps" style=" letter-spacing: 4px;color: black;" v-else-if="peopleInfo.use_status == 0">参会码 {{peopleInfo.qrcode}}</p>
        <p class="ps" style=" 4px;color: red;" v-else-if="peopleInfo.use_status == 1">
          该门票已使用
         <!-- <span>2020-05-19 12:33:23</span>-->
        </p>
        <p style="padding-bottom:20px;">电子门票,出示二维码给会场工作人员扫码签到</p>
      </div>
    </div>

<footerFixed v-if="peopleInfo.conference.name != ''" :id="peopleInfo.conference.id" :jump-page="peopleInfo.conference.jump_page"/>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2';
  import { formatDates ,formatWeekDate } from "../../assets/js/date";
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
  data() {
    return {
      id:'',
      footerNav: false,
      peopleInfo:{
        conference:{
          name:''
        },
        qrcode:''
      }
    };
  },
    components: { QRCode ,footerFixed},
  /* 时间过滤 */
  filters: {
    formatDates,//调用方法formatTime(1575346406, 'Y年M月D日 h:m:s')
    formatWeekDate //
  },
  created: function(){
    var _this = this;
    _this.id = _this.$route.params.id;
    _this.onLoad();
    _this.$WXConfig.wxShowMenu({ifshare:false,that:_this,data:''});
  },
  methods: {
    //生成二维码
    creatQrCode(code) {
      var qrcode = new QRCode('qrcode', {
        text:code,
        width: 300,
        height: 300,
        colorDark: '#000000',
        colorLight: '#ffffff',
      })
     },
    //打开底部链接
    openFooterNav(val) {
      //   this.$toast(val);
      if (this.footerNav) {
        this.footerNav = false;
      } else {
        this.footerNav = true;
      }
    },
    //待完善人员列表
    onLoad() {
      var _this = this;
      _this.page++;
      let url = "/ac1/conference/enrollMemberDetail";
      let params = {
        id:_this.id
      };
      _this.$get(url, params).then(res => {
        if (res.code == "1") {
          _this.peopleInfo = res.posts;
          _this.$nextTick (function () {
            if(_this.peopleInfo.qrcode == ''){
              this.creatQrCode('暂无');
            }else{
              this.creatQrCode(_this.peopleInfo.qrcode);
            }
          });
          _this.peopleInfo.fields = JSON.parse(_this.peopleInfo.fields);
        }else{
          _this.$toast(res.msg);
          setTimeout(function(){
            _this.$router.go(-1);
          },1000)
        }
      });
    },
    goadd() {
      var _this = this;
      var cbox= _this.peopleInfo;
      var _thisbox = {c_id:cbox.conference_id,t_id:cbox.ticket_id,order_no:'',has_id:cbox.id,fields:cbox.fields,main:cbox.main};
      sessionStorage.setItem('order_isok_'+_thisbox.t_id,JSON.stringify(_thisbox));
      this.$router.push('/orderperfect/'+_thisbox.t_id);
    }
  }
};
</script>

<style lang="less">
  .ticket-title {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  font-size: 28px;
  letter-spacing: 1px;
  overflow: hidden;
  .message {
    background-color: white;
    padding: 34px 30px 34px 30px;
    margin-bottom: 30px;
    .van-row {
      margin-bottom: 25px;
    }
    .t_box{
      overflow: hidden;
      width: 100%;
      .van-col{
        overflow: hidden;
        display: flex;
        p{
          word-break:break-all;
          max-width: 500px;
        }
      }
    }
  }
  .p {
    width: 100%;
    background-color: #2b68da;
    color: white;
    padding: 15px 30px;
  }
  .wechart {
    margin: 0px 30px 95px 30px;
    border-radius: 10px;
    overflow: hidden;
    background-color: white;
    box-shadow: 5px 5px 15px #c1c1c1;
    .ticket_num {
      padding: 17px 28px;
      background-color: #fff6f3;
      .van-col{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .erwei {
      width: 364px;
      height: 364px;
      margin: auto;
      margin-top: 90px;
      canvas{
        width: 100%;
        height: 100%;
      }
      img{
        width: 100%;
        height: 100%;
      }
    }
    .foot_text {
      text-align: center;
      margin-top: 57px;
      p {
        color: #a4a3a3;
      }
      .ps {
        width: 100%;
        margin-bottom: 37px;
        font-weight: 600;
        font-size: 30px;
      }
    }
  }
}
</style>
